/**
 * 订单管理 礼品卡管理
 */
<template>
  <div>
    <!-- 面包屑导航 -->
    <el-breadcrumb separator-class="el-icon-arrow-right">
      <el-breadcrumb-item :to="{ path: '/' }">首页</el-breadcrumb-item>
      <el-breadcrumb-item>礼品卡管理</el-breadcrumb-item>
    </el-breadcrumb>

    <!-- 搜索筛选  accordion -->
    <el-collapse ref="coll" v-model="activeCollapseNames" style="margin-top: 20px !important;">
      <el-collapse-item name="search">
        <template slot="title">
          <!-- 搜索区域折叠行 -->
          <div style="display: flex; align-items: center; justify-content: space-between; flex-wrap: wrap; width: 100%;" @click.stop="void 0">
            <div style="display: flex; flex-wrap: nowrap; align-items: center;">
              <el-form ref="queryForm" :inline="true" :model="queryParams" class="user-search">
                <el-form-item label="搜索：">
                  <el-input size="small" v-model="queryParams.account" placeholder="输入礼品卡"></el-input>
                </el-form-item>
                <el-form-item label="">
                  <el-input size="small" v-model="queryParams.name" placeholder="输入学员姓名"></el-input>
                </el-form-item>
                <el-form-item label="">
                  <el-input size="small" v-model="queryParams.idcard" placeholder="输入身份证号"></el-input>
                </el-form-item>
                <el-form-item label="">
                  <el-input size="small" v-model="queryParams.phone" placeholder="输入手机号"></el-input>
                </el-form-item>

                <el-form-item>
                  <el-button size="small" type="primary" icon="el-icon-arrow-down" @click="toggleCollapse">{{ activeCollapseNames.length ? "收起" : "更多" }}</el-button>
                  <el-button size="small" type="primary" icon="el-icon-search" @click="search">搜索</el-button>
                  <el-button size="small" type="primary" icon="el-icon-plus" @click="handleAdd()" v-if="systemFlag != 1">生成礼品卡</el-button>
                </el-form-item>
              </el-form>
            </div>
          </div>
        </template>

        <!-- 这是折叠的内容区域 -->
        <div
          style="display: flex; flex-wrap: wrap;"
        >
          <el-form
            :model="queryParams"
            ref="queryForm2"
            :inline="true"
            label-width="68px"
          >
            <el-form-item label="">
              <el-cascader
                size="small"
                placeholder="选择科目"
                style="width: 100%"
                v-model="queryParams.subjectId"
                :options="treeOptions"
                emitPath="false"
                :props="{ emitPath:false }"
                clearable
              ></el-cascader>
            </el-form-item>
            <el-form-item label="">
              <el-select size="small" v-model="queryParams.isActivate" placeholder="请选择是否激活" clearable>
                <el-option v-for="x in sfOptions" :label="x.dictLabel" :value="x.dictValue" :key="x.dictValue"></el-option>
              </el-select>
            </el-form-item>
            <el-form-item label="">
              <el-select size="small" v-model="queryParams.isAssociated" placeholder="请选择是否关联" clearable>
                <el-option v-for="x in sfOptions" :label="x.dictLabel" :value="x.dictValue" :key="x.dictValue"></el-option>
              </el-select>
            </el-form-item>
            <el-form-item label="" v-if="systemFlag == 1">
              <el-input size="small" v-model="queryParams.orgName" placeholder="输入客户名称"></el-input>
            </el-form-item>
          </el-form>
        </div>
      </el-collapse-item>
    </el-collapse>


    <!--列表-->
    <el-table
      ref="multipleTable"
      size="small"
      :data="listData"
      highlight-current-row
      v-loading="loading"
      border
      element-loading-text="拼命加载中"
      style="width: 100%;"
      @selection-change="handleSelectionChange"
      :row-key="(row) => { return row.id }"
    >
<!--        <el-table-column type="selection" width="55" align="center" :reserve-selection="true" />-->
      <el-table-column label="序号" align="center" type="index" :index="indexMethod" width="60"/>
      <el-table-column prop="orgName" label="客户名称"/>
      <el-table-column prop="account" label="礼品卡号"/>
      <el-table-column prop="password" label="密码"/>
      <el-table-column prop="isActivate" label="是否激活">
        <template slot-scope="scope">
          {{ scope.row.isActivate == 1 ? '是' : '否' }}
        </template>
      </el-table-column>
      <el-table-column prop="isAssociated" label="是否关联">
        <template slot-scope="scope">
          {{ scope.row.isAssociated == 1 ? '是' : '否' }}
        </template>
      </el-table-column>
      <el-table-column prop="activateSubjectName" label="激活科目"/>
      <el-table-column prop="activateTime" label="激活时间"/>
      <el-table-column prop="valiteTime" label="到期时间"/>
      <el-table-column prop="associatedAccount" label="关联账号"/>
      <el-table-column prop="name" label="学员姓名"/>
      <el-table-column prop="idcard" label="身份证号"/>
      <el-table-column prop="phone" label="手机号"/>

<!--      <el-table-column align="center" label="操作" width="150">
        <template slot-scope="scope">
          <el-tooltip
            class="item"
            effect="dark"
            content="删除"
            placement="top"
          >
            <el-button
              size="mini"
              type="danger"
              icon="el-icon-delete"
              @click="handleDel(scope.$index, scope.row)"
            >
            </el-button>
          </el-tooltip>
        </template>
      </el-table-column>-->
    </el-table>
    <!-- 分页组件 -->
    <Pagination v-bind:child-msg="pageparm" @callFather="callFather" style="position: fixed; bottom: 2vh;"></Pagination>

    <!-- 编辑界面 -->
    <el-dialog :title="title" :visible.sync="editFormShow" width="35%" top="5vh" :close-on-click-modal="false" @click="closeDialog" append-to-body>
      <el-form label-width="100px" ref="form" :model="form" :rules="rules">
        <el-form-item label="数量" prop="num">
          <el-input size="small" maxLength="10" v-model="form.num" placeholder="请输入礼品卡数量" @input="formatInportData($event,'10','num',form)"></el-input>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button size="small" @click='closeDialog("edit")'>取消</el-button>
        <el-button size="small" type="primary" :loading="loading" class="title" @click="submitForm('form')">确定</el-button>
      </div>
    </el-dialog>



  </div>
</template>

<script>
import {formatInportData, timestampToTime} from '../../utils/util'
import Pagination from '../../components/Pagination'
import Template from "../../components/template";
import {generateGiftCard, queryGiftCardList,} from "../../api/order";
import {selectAreaTree} from "../../api/subjectTree";

export default {
  data() {
    return {
      systemFlag: JSON.parse(localStorage.getItem('userdata')).systemFlag,
      ids: [],    // 多选框ids
      dateValue: [],
      loading: false, //是显示加载
      editFormShow: false, //控制编辑页面显示与隐藏
      title: '添加',
      form: {},
      rules: {
        num: [
          { required: true, message: '请输入数量', trigger: 'blur' }
        ],
      },
      // rules表单验证
      queryParams: {
        page: 1,
        size: 10,
      },
      listData: [], //用户数据
      // 分页参数
      pageparm: {
        currentPage: 1,
        pageSize: 10,
        total: 10
      },

      // 左侧树
      treeArr: [],  // 默认展示第二级树节点
      treeOptions: undefined,

      // 查询折叠
      activeCollapseNames: [],
      sfOptions: [
        { dictLabel: '是', dictValue: 1 },
        { dictLabel: '否', dictValue: 0 },
      ],

    }
  },
  // 注册组件
  components: {
    Template,
    Pagination,
  },

  /**
   * 创建完毕
   */
  created() {
    this.getdata();
    this.selectAreaTree();
  },

  /**
   * 里面的方法只有被调用才会执行
   */
  methods: {
    formatInportData,
    timestampToTime,
    indexMethod(index) {
      return (this.pageparm.currentPage - 1) * this.pageparm.pageSize + index + 1;
    },
    // 查询折叠
    toggleCollapse() {
      this.activeCollapseNames = this.activeCollapseNames.length ? [] : ["search"];
    },

    // 查询 科目树
    selectAreaTree() {
      selectAreaTree({}).then(res => {
        if (res.code == 200) {
          this.treeOptions = res.data;
          res.data.forEach(x => {
            this.treeArr.push(x.value)
          })
        }
      })
    },

    // 获取提现历史数据
    getdata() {
      this.loading = true
      /***
       * 调用接口，注释上面模拟数据 取消下面注释
       */
      queryGiftCardList(this.queryParams).then(res => {
        this.loading = false
        if (res.code != 200) {
          this.$message({
            type: 'info',
            message: res.msg
          })
        } else {
          this.listData = res.data.content
          // 分页赋值
          this.pageparm = res.data.pageparm
          this.pageparm.pageSize = 10;
        }
      })
      .catch(err => {
        this.loading = false
        this.$message.error('加载失败，请稍后再试！')
      })
    },
    // 分页插件事件
    callFather(parm) {
      this.queryParams.page = parm.currentPage
      this.queryParams.size = parm.pageSize
      this.getdata()
    },
    // 搜索事件
    search() {
      this.queryParams.page = 1;
      this.getdata()
    },
    // 多选框选中数据
    handleSelectionChange(val) {
      this.ids = val;
    },

    // 生成礼品卡
    handleAdd(index, row) {
      this.editFormShow = true
      this.title = '生成礼品卡'
      this.form = {};
    },

    submitForm(editData) {
      this.$refs[editData].validate(valid => {
        if (valid) {
          generateGiftCard(this.form.num).then(res => {
            this.editFormShow = false
            this.loading = false
            if (res.code == 200) {
              this.getdata()
              this.form = {};
              this.$message({
                type: 'success',
                message: '保存成功！'
              })
            } else {
              this.$message({
                type: 'info',
                message: res.msg
              })
            }
          })
            .catch(err => {
              this.editFormShow = false
              this.loading = false
              this.$message.error(err.response.data.msg)
            })
        } else {
          return false
        }
      })
    },

    // 关闭编辑、增加弹出框
    closeDialog() {
      this.editFormShow = false
    },


  }
}
</script>

<style scoped>
.user-search {
  margin-top: 10px;
}
.userRole {
  width: 100%;
}
.btnCss {
  margin-top: 10px;
  margin-left: 0px !important;
}

/* 导出 */
.menu-item {
  display: block;
  line-height: 20px;
  text-align: center;
  margin-top: 2px;
}
.menu-item:hover{
  background-color: #66b1ff;
  color: white;
  cursor:pointer;
}
.menu {
  /*height: 35px;*/
  width: 90px;
  position: absolute;
  border: 1px solid #999;
  border-radius: 10px;
  background-color: #f4f4f4;
  padding: 5px 0px;
}

.el-dropdown {
  vertical-align: top;
}
.el-dropdown + .el-dropdown {
  margin-left: 10px;
}
.el-icon-arrow-down {
  font-size: 12px;
}

/deep/ .el-drawer {
  background-color: #F5F5F5 !important;
  padding: 15px !important;
}

/deep/ .el-collapse {
  margin-top: 10px !important;
  border-top: 0px solid #EBEEF5 !important;
  border-bottom: 0px solid #EBEEF5 !important;
}

/deep/ .el-collapse-item__content {
  padding-bottom: 0px;
}

/deep/ .el-collapse-item__arrow{
  display: none;
}

</style>





// WEBPACK FOOTER //
// src/views/order/giftCard.vue